import React, { useContext, useEffect } from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CONTEXTS } from 'figshelf-modules';
import Login from '../pages/Login';
import Register from '../pages/Register';
import { AUTH_MODAL_VIEWS, useAuthModal } from '../contexts/AuthModalContext';

const AuthModal = () => {
  const { isOpen, view, close } = useAuthModal();
  const auth = useContext(CONTEXTS.AuthContext);

  useEffect(() => {
    if (!isOpen) return;
    if (auth?.isSignedIn) {
      close();
    }
  }, [auth?.isSignedIn, close, isOpen]);

  return (
    <Dialog open={isOpen} onClose={close} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <IconButton onClick={close} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ pt: 0 }}>
        {view === AUTH_MODAL_VIEWS.LOGIN ? <Login embedded /> : <Register embedded />}
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
